import { useMemo } from "react";
import { useGetAccountStructureQuery } from "@features/structures/api/accountsStructure.api";
import { TicketHebType } from "@models/types";

/**
 * Loads account structure fields for the browse table (columns double as inline filters) by Hebrew account type key.
 */
export function useAccountTypeStructures(accountType: TicketHebType) {
  const { data: structure } = useGetAccountStructureQuery(accountType);

  const tableStructure = useMemo(
    () => structure?.filter((field) => field.show_browse),
    [structure],
  );

  return { tableStructure };
}
